import { WishlistsType } from 'b2b-common/core/account/api/wishlists';
import {
  CLEAR_WISHLISTS_SEARCH,
  FETCH_WISHLISTS_SEARCH,
  FETCH_WISHLISTS_SEARCH_FULFILLED,
  FETCH_WISHLISTS_SEARCH_REJECTED,
} from './actionTypes';
import {
  ClearWishlistsSearchAction,
  FetchWishlistsSearchAction,
  FetchWishlistsSearchFulfilledAction,
  FetchWishlistsSearchRejectedAction,
} from './types';

export const fetchWishlistsSearch = (searchQuery: string): FetchWishlistsSearchAction => ({
  type: FETCH_WISHLISTS_SEARCH,
  payload: {
    searchQuery,
  },
});

export const fetchWishlistsSearchFulfilled = (response: WishlistsType): FetchWishlistsSearchFulfilledAction => ({
  type: FETCH_WISHLISTS_SEARCH_FULFILLED,
  payload: {
    data: response,
  },
});

export const fetchWishlistsSearchRejected = (error: ErrorType): FetchWishlistsSearchRejectedAction => ({
  type: FETCH_WISHLISTS_SEARCH_REJECTED,
  payload: {
    error,
  },
});

export const clearWishlistsSearch = (): ClearWishlistsSearchAction => ({
  type: CLEAR_WISHLISTS_SEARCH,
});
